import React from 'react';
import { Flex, Icon, Image, Text } from '@chakra-ui/react';
import { MdOutlineTimer, MdPeople } from 'react-icons/md';
import { useBoardGame } from '../hooks/useBoardGame';

interface BoardGameItemProps {
  boardGameId: string;
  actionButton?: React.ReactNode;
}

const BoardGameItem: React.FC<BoardGameItemProps> = ({
  boardGameId,
  actionButton,
}) => {
  const boardGame = useBoardGame(boardGameId);

  if (!boardGame) {
    return null;
  }

  return (
    <Flex alignItems="center">
      <Image
        border="2px solid #515151"
        borderRadius="50%"
        src={boardGame.thumbnail}
        width="50px"
        height="50px"
        minW="50px"
        minH="50px"
      />
      <Flex
        flexDir="column"
        alignItems="start"
        width="100%"
        flex="1"
        fontWeight="semibold"
        ml="12px"
        color="#383838"
        mr="auto"
      >
        <Flex alignItems="center">
          <Icon as={MdOutlineTimer} />
          <Text fontSize="12px" mr="12px">
            {boardGame.playingTime}분
          </Text>
          <Icon as={MdPeople} />
          <Text fontSize="12px">
            {boardGame.minPlayerNum}~{boardGame.maxPlayerNum}
          </Text>
        </Flex>
        <Text fontSize="16px">{boardGame.koreanName || boardGame.name}</Text>
      </Flex>
      {actionButton}
    </Flex>
  );
};

export default BoardGameItem;
